import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { batch, useDispatch, useSelector } from 'react-redux';

import Query from 'dashboard-services/api/Query';
import { Fetching, globalActions } from 'primary-components';

import { imagePreviewActions } from 'actions/modules/tools';
import getApiConfig from 'api/ApiConfig';
import { filesDatalakeQueries } from 'queries/modules/datalake';
import { sendEvent } from 'services/GAService';

import classNames from 'classnames';
import './ImagePreview.scss';

const ImagePreview = () => {
  const dispatch = useDispatch(),
        [isClosing, setIsClosing] = useState(),
        [isFetching, setIsFetching] = useState(true),
        { fileId, provider } = useSelector(state => state.toolsState.imagePreviewState),
        getMetadataRequest = useRef(),
        closingTimer = useRef(),
        close = useCallback(() => {
          setIsClosing(true)
          closingTimer.current = setTimeout(() => {
            batch(() => {
              dispatch(imagePreviewActions.changeValue(undefined, "fileId"))
              dispatch(imagePreviewActions.changeValue(undefined, "provider"))
              dispatch(imagePreviewActions.changeValue(false, "isOpen"))
            })
            setIsClosing(false)
          }, 200)
        }, [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(dispatch(getApiConfig()))
            .withOnParse(response => Promise.resolve(response))
            .withHeader("Target", provider, true)
            .withFetching(false)
        , [dispatch, provider]),
        { data: infoResponse } = filesDatalakeQueries.useGetFileDefinition({ getQueryBuilder, id: fileId, refetchOnMount: false, refetchOnReconnect: false, refetchOnWindowFocus: false }),
        location = useMemo(() => infoResponse?.headers?.get("Location"), [infoResponse])

  useEffect(() => () => {
    getMetadataRequest.current?.cancel()
    clearTimeout(closingTimer.current)
    close()
  }, [close])

  useEffect(() => {
    const event = {
      category: "view_item",
      action: "image_preview",
      label: "tool",
    };
    dispatch(sendEvent(event))
  }, [dispatch])

  return createPortal(
    <div className={classNames(
      "image-previewer",
      { "image-previewer--is-closing": isClosing }
    )}>
      <div 
          className="image-previewer__background"
          onClick={close}
      />
      <img
          loading="eager"
          onError={() => {
            setIsFetching(false)
            dispatch(globalActions.getMessageStore()).error("Image could not be loaded.")
          }}
          onLoad={() => setIsFetching(false)}
          src={location}
      />
      <Fetching
          className="image-previewer__fetching"
          isFetching={isFetching}
          size={80}
      />
    </div>
  , document.body)
}

export default memo(ImagePreview)